export const QUERY_KEYS = {
  IMAGE_SEARCH_RESULT: 'image-search-result'
};
